import React from 'react';
import Marquee from '../Core/Marquee';
import WebsiteImage from 'components/WebsiteImage';
import ContentfulRichText from 'components/RichText/ContentfulRichText';
import { getEntry } from 'components/Contentful/ContentfulLayout/utils/entriesHelpers';
import './styles.css';

const PowertheNation = ({ entries = [] }) => {
  const image = getEntry('image', entries);
  const copy = getEntry('copy', entries);

  return (
    <>
      <div className="ptn-marquee-wrapper overflow-hidden z-0 absolute w-full h-[340px] bg-darkest">
        <div className="absolute -right-2 -left-1 bottom-[100px] bg-titan-blue-3 rotate-2 h-[54px]">
          <Marquee autoFill>
            <p className="m-0 text-white">International Day of the Trades &bull;</p>
          </Marquee>
        </div>
      </div>
      <div className="relative mx-auto my-0 max-w-[--max-width] pt-[70px] pb-[50px] px-7 lg:px-[70px]">
        <div className="ptn-container relative flex flex-row bg-darkest border-solid border-2 border-titan-blue-3 rounded">
          <div className="ptn-bg absolute w-full h-full opacity-20" />
          <div className="image-container hidden lg:flex basis-1/3 relative h-fit self-end">
            <WebsiteImage
              {...image}
              className="transform scale-110 -translate-y-9 -translate-x-4"
            />
          </div>
          <div className="copy-container px-7 py-12 lg:pr-7 lg:basis-2/3 self-start">
            <ContentfulRichText
              className="ptn-copy [&>h2]:text-white [&>h2]:mb-0 [&>p]:mb-0 [&>p]:text-white [&>p]:lg:text-[20px] gap-7"
              richText={copy}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default PowertheNation;
